import React from "react";
import TransactionTable from "../transaction-table";
import { TransactionCards } from "../../../components/cards/transaction-card";

const Payments = ({
  data,
  statistics,
  selectedStatus,
  handleStatusChange,
  currentPage,
  handlePageChange,
  activeTab,
  loading
}: any) => {
  return (
    <div>
      <TransactionCards statistics={statistics} activeTab={activeTab} />
      <TransactionTable
        data={data}
        selectedStatus={selectedStatus}
        handleStatusChange={handleStatusChange}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        loading={loading}
      />
    </div>
  );
};

export default Payments;
